/**
 * This script contains helper functions to render generic UI components.
 */

import type { VNode } from '@stencil/core';
import { h } from '@stencil/core';

h('div', { color: '' });

function parseChildren(children: Array<string | any>): Array<VNode | null> {
  if (children.length < 1) {
    return [null];
  }

  return children.map((child) => {
    if (typeof child === 'string') {
      return child as unknown as VNode;
    }

    if (child.tag === 'sy-app-router') {
      child.children = [
        {
          tag: 'slot',
          node: {},
          children: [],
        },
      ];
    }
    return h(child.tag, child.node, parseChildren(child.children));
  });
}

/**
 * Generates the render of an UI Component from a JSON parsed content.
 * @param componentContent UI component's content.
 */
export function renderComponent(componentContent: any): VNode {
  return h(componentContent.tag, componentContent.node, parseChildren(componentContent.children));
}
